import { createToken } from '@react-apps/core';
import type { DeliveryRepositoryImpl } from '../data/repositories/delivery.repository.impl';

export const DeliveryRepositoryToken =
  createToken<DeliveryRepositoryImpl>('DeliveryRepository');
